var exports = {
  "zr": "x620889e6--107fee--root",
  "lZ": "x620889e6--107fee--phone",
  "Cv": "x620889e6--107fee--about",
  "Hr": "x620889e6--107fee--operator",
};

module.exports = exports;
